import type { SxProps, Theme } from '@mui/material';
import { keyframes } from '@mui/material/styles';

const popIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.6);
  }
  70% {
    opacity: 1;
    transform: scale(1.08);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

export const checkmarkPopInSx: SxProps<Theme> = {
  animation: `${popIn} 400ms ease both`,
  transformOrigin: 'center',
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
};
